import styled from 'styled-components'

export const FixedWidthPageContainer = styled.div`
  width: 100vw;
  height: 100vh;
  padding: 32px;
`
